import styled from 'styled-components'

export const StyleIconSvg = styled.span`
  .min-h-\[50px\] {
    height: 50px;
  }
`
